export default{

    name: 'sclm',
    component: () => import(/* webpackChunkName: "sclm" */ '@/modules/sclm/views/SclmApp.vue'),
    childen:{

        name: 'users',
        component: () => import(/* webpackChunkName: "sclm" */ '@/modules/sclm/views/SclmUsers.vue'),

    }
}